import AsyncStorage from '@react-native-async-storage/async-storage';

import EventObject from '../models/event_object';
import {refreshToken} from '../../webservice/putrajaya_api';
import { createAction } from "@utils";
import { call, put, select } from 'redux-saga/effects';

function delay(time) {
    return new Promise(resolve => setTimeout(resolve, time));
  }

// Generic function to handle API calls and token refresh
function* handleApiCall(apiFunction, params) {
    let { memberId, authToken } = params;
    // console.log('🔧 handleApiCall - Starting API call with authToken:', authToken ? `${authToken}...` : null);
    
    let json = yield call(apiFunction, params);
    let eventObject = new EventObject(json);
  
    if (eventObject.isTokenExpired()) {
      // console.log('🔧 handleApiCall - Token expired, attempting refresh for memberId:', memberId);
      const newAuthToken = yield call(refreshAuthToken, memberId, authToken);
  
      if (newAuthToken) {
        // console.log('🔧 handleApiCall - Token refresh successful, retrying API call with new token:', `${newAuthToken.substring(0, 20)}...`);
        // Update authToken in params for retry
        params.authToken = newAuthToken;
        yield delay(1000);
        json = yield call(apiFunction, params);
        eventObject = new EventObject(json);
      } else {
        // console.log('🔧 handleApiCall - Token refresh failed, returning expired token error');
      }
    } else {
      // console.log('🔧 handleApiCall - API call completed successfully without token refresh');
    }
  
    return eventObject;
}

async function refreshAuthToken(memberId, authToken) {
    try {
      // console.log('🔧 refreshAuthToken - Starting token refresh for memberId:', memberId, 'with authToken:', authToken ? `${authToken}...` : null);
      const json = await refreshToken({memberId,authToken});
      
      // console.log('🔧 refreshAuthToken - API response:', JSON.stringify(json));
      const eventObject = new EventObject(json);
  
      if (eventObject.success === true) {
        // console.log('🔧 refreshAuthToken - Success! New authToken:', eventObject.result.authToken ? `${eventObject.result.authToken}...` : null);
        await saveAuthTokenToStorage(eventObject.result);
        return eventObject.result.authToken
        await createAction('member/setAuthToken')(eventObject.result);
      } else {
        // console.log('🔧 refreshAuthToken - Failed, eventObject.success:', eventObject.success);
      }
    } catch (err) {
      // console.log('🔧 refreshAuthToken - Error occurred:', err);
    }
    return null; // Return null if refresh fails
}

function getUserFromStorage() {
    return AsyncStorage.getItem('@profile', (err, result) => {
      // log('@profile ', result);
      if (err) {
        log('@profile Error: ', err);
      }
  
      return result;
    });
  }

async function saveAuthTokenToStorage(data) {
    let userString = await getUserFromStorage()
    if (userString) {
      let user = JSON.parse(userString)
      if (user) {
        //console.log(user)
        user.authToken = data.authToken;
        AsyncStorage.setItem('@profile', JSON.stringify(user));
      }
    }
  }

export default handleApiCall